// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, initializeAuth, inMemoryPersistence, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { IS_VATAR } from './vatar/env';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

 const firebaseConfig = {
  apiKey: "AIzaSyB10BtUUcRgIN-bb8Nqv2cL6QE59VHiawY",
  authDomain: "nameit-a5921.firebaseapp.com",
  projectId: "nameit-a5921",
  storageBucket: "nameit-a5921.firebasestorage.app",
  messagingSenderId: "505955535265",
  appId: "1:505955535265:web:0f7369a77a08215c20a3e0",
  measurementId: "G-F2HENRH527"
 };

// const firebaseConfig = {
//  apiKey: "AIzaSyB1I3ZotlXDOKsIuzp3SP_8w-R3HXjRQGk",
//  authDomain: "rent-flow-96ebf.firebaseapp.com",
//  projectId: "rent-flow-96ebf",
//  storageBucket: "rent-flow-96ebf.appspot.com",
//  messagingSenderId: "723962143803",
//  appId: "1:723962143803:web:db1fcab5c0ec504d26281e"
//};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
// Inside the Lagos Life frame, storage is partitioned or blocked, and every visit
// signs in again with a fresh Vatar session, so keep auth in memory only.
export const auth = IS_VATAR
  ? initializeAuth(app, { persistence: inMemoryPersistence })
  : getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Dev-only: send callable functions (payments etc.) to the local Functions
// emulator, e.g. to test Paystack with test keys without touching the live
// functions. Opt-in via VITE_FUNCTIONS_EMULATOR=1 (see `vite --mode`); never in
// a production build. Every getFunctions() call returns this same instance.
if (import.meta.env.DEV && import.meta.env.VITE_FUNCTIONS_EMULATOR === '1') {
  connectFunctionsEmulator(getFunctions(app), '127.0.0.1', 5001);
}

// Dev-only: each browser TAB gets its own anonymous Firebase session instead
// of sharing one. Lets us open multiple tabs locally and have them act as
// genuinely separate players in the same room — otherwise every tab reuses
// the same anonymous UID and multiplayer flows can't be tested end-to-end
// without real separate devices. Opt-in via ?freshSession=1 so a normal
// `npm run dev` tab still behaves like production; never runs in a
// production build (import.meta.env.DEV).
//
// Firebase Auth defaults to IndexedDB persistence, which — like
// localStorage — is shared across every tab of the same origin, so
// signInAnonymously() can still resolve to a UID restored from a previous
// tab's session if it runs before this completes. main.jsx awaits
// `authReady` before rendering the app for exactly that reason: switching
// persistence must finish before anything calls signInAnonymously.
export const authReady =
  import.meta.env.DEV && new URLSearchParams(window.location.search).has('freshSession')
    ? setPersistence(auth, browserSessionPersistence).catch((err) =>
        console.warn('[dev] Failed to set session-only auth persistence:', err)
      )
    : Promise.resolve();

export default app;
